<template>
    <div style="position: relative; ">
        <div class="v-flex">
            <c-index
                title          = "Kunden"
                :items         = "items"
                :criterion     = "customer.criterion"
                :filter-on     = "customer.filterOn"
                :filter        = "indexFilter"
                :filter-height = "filterHeight"
                :enable-search = "false"
                :miminize      = "minimize"
                :pre-index-height = "preIndexHeight"
                @selected      = "onCustomer"
                @clear-filter  = "onClearFilter"
                ref            = "index"
                class          = "w-75"
            >
                <template v-slot:filter>
                    <m-customer-filter
                        @changed     = "onFilter"
                        :text-search = "enableSearch"
                        :show-misc   = "showMisc"
                        ref          = "filter"
                    />

                    <v-row
                        class="no-frame unknown mt-1 mb-3 mr-0"
                        v-if="showUnrefFilter"
                        :class="customer.selected && customer.selected.id === 0 ? 'unknown-selected' : ''"
                    >
                        <a @click="onUnknown" class="w-100">
                            {{ unrefText }}
                        </a>
                    </v-row>
                </template>

                <template v-slot:pre-index>
                    <slot name="pre-index" />
                </template>

                <template v-slot:item="{ item }">
                    <div class="v-flex w-100">
                        <div class="customer-name">
                            {{ item.name }}
                        </div>
                        <v-spacer />
                        <slot name="flags" v-bind:item="item" />
                        <c-tag
                            v-if      = "isType(item, 1) && showTags"
                            label     = "LM"
                            :active   = "contractStatistic(item, 1).active > 0"
                            :selected = "isSelected(customer, item)"
                            style="margin-right: 2px;"
                        />
                        <c-tag
                            v-if      = "isType(item, 2) && showTags"
                            label     = "DLS"
                            :active   = "contractStatistic(item, 2).active > 0"
                            :selected = "isSelected(customer, item)"
                        />
                    </div>
                </template>
                <template v-slot:detail="{ item }">
                    <slot name="detail" v-bind:item="item"></slot>
                </template>
            </c-index>
        </div>
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import MCustomerFilter from "@/modules/msd/company/customer/components/main/MCustomerFilter";
import CTag            from "@/modules/core/components/utils/CTag";
import Customer        from "@/modules/msd/company/customer/service/Customer";
import CIndex          from "@/modules/core/components/utils/CIndex";

export default {
    name: "CCustomerIndex",
    components: {
        CIndex,
        CTag,
        MCustomerFilter
    },

    props: {
        minimize: {

        },
        enableSearch: {

        },

        filterHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 155;
            }
        },

        criterion: {

        },

        preIndexHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },

        showMisc: {
            required: false,
            type: Boolean,
            default : function () {
                return true;
            }
        },

        showTags: {
            required: false,
            type: Boolean,
            default : function () {
                return true;
            }
        },

        showUnrefFilter: {
            required: false,
            type: Boolean,
            default : function () {
                return true;
            }
        },

        unrefText: {
            required: false,
            type    : String,
            default: function () {
                return "Anlagen ohne Kunden"
            }
        }
    },

    data: () => ({
        customer: {
            selected   : null,
            criterion  : null,
            filterOn   : false,
            lim        : false,
            myCustomers: false
        },
    }),

    created() {
        this.$bus.$on(this.$events.search, this.onCriterion);
        this.$bus.$on(this.$events.searchcustomer, this.onSearch);
        this.$bus.$on(this.$events.clearFilter, this.onClearFilter);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.search, this.onCriterion);
        this.$bus.$off(this.$events.searchcustomer, this.onSearch);
        this.$bus.$off(this.$events.clearFilter, this.onClearFilter);
    },

    watch: {
        criterion () {
            this.onCriterion(this.criterion);
        }
    },

    mounted() {
        this.onFilter();
    },

    computed: {
        items () {
            return this.$store.getters.customer.filter(item => item.id !== 0);
        },

        unknown () {
            return this.$store.getters.customer.find(item => item.id === 0);
        },

        myCustomerList () {
            if (this.$store.getters.preferences.customer) {
                return this.$store.getters.preferences.customer.map(customer => customer.id);
            }

            return null;
        }
    },

    methods: {
        indexFilter (item, search) {
            if (this.myCustomers && this.myCustomerList) {
                if (this.myCustomerList.filter(c => c === item.id).length === 0) {
                    return false;
                }
            }

            if (search && !Core.filter.includes(item.name, search)) {
                return false;
            }

            return this.$refs.filter.match(item);
        },

        /**
         * Is called when the selected custumer has been changed.
         * @param customer the new selected cutomer. null, if no customer is selected.
         */
        onCustomer(customer) {
            this.customer.selected = customer;
            this.$emit("changed", customer);
        },

        /**
         * Is called when the search text in the title has been changed
         * @param criterion the new search criterion
         */
        onCriterion (criterion) {
            if (!this.enableSearch) {
                this.customer.criterion = criterion;
            }
        },

        /**
         * Is called when the search text in the filter or the selected customer has been changed
         * @param data contains the search criterion of the selected customer
         */
        onSearch (data) {
            if (this.myCustomers !== data.myCustomers) {
                this.myCustomers = data.myCustomers;
                this.customer.criterion = data.criterion;

                this.$refs.index.refresh();
                return;
            }

            this.myCustomers = data.myCustomers;
            this.customer.criterion = data.criterion;
        },

        onClearFilter() {
            this.$refs.filter.clearFilter();
            this.customer.selected = null;
            this.$emit("changed", null);
            this.onFilter();
        },

        onFilter() {
            this.customer.filterOn = this.$refs.filter.filterOn();
            this.$refs.index.refresh();
        },

        onUnknown () {
            this.$refs.index.onItem (this.unknown)
        },

        isType(item, type) {
            return Customer.isType(item, type);
        },

        contractStatistic(item, type) {
            return Customer.contractStatistic(item, type);
        },

        isSelected(customer, item) {
            return customer && customer.selected && customer.selected.id === item.id;
        },

        setCustomer (customer) {
            this.customer.selected = customer;
            this.$refs.index.setSelected(customer);
        }
    }
}
</script>

<style scoped>

.customer-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>

<style lang="scss" scoped>

.unknown {
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
    border-radius: 4px;
    height: 33px;
}

.unknown a {
    color: gray;
    padding-top: 4px;
    padding-left: 10px;
}

.unknown-selected {
    background-color: lightgrey;
}

</style>